export default {
  data() {
    return {
      errors: false,
      message: '',
      nocamera: require('@/svg/nocamera.svg')
    };
  },
  methods: {
    /**
     * 获取摄像头错误状态
     */
    mediaErrorState() {
      let states = {
        NotReadableError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.设备获取失败');
        },
        NotAllowedError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.未获取到设备');
        },
        NotFoundError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.摄像头找不到错误');
        },
        SecurityError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.摄像头安全错误');
        },
        AbortError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.摄像头中止错误');
        },
        OverconstrainedError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.无法满足要求错误');
        },
        TypeError: () => {
          this.errors = true;
          this.message = this.$t('mediaError.类型错误');
        },
        success: () => {
          this.errors = false;
          this.message = '';
        }
      };
      return {
        show: (result) => {
          states[result] && states[result]();
        }
      };
    },
    /**
     * 摄像头获取错误显示
     */
    getUserMediaError(name) {
      this.mediaErrorState().show(name);
    }
  }
};
